var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"scroll-to-top hidden-print",attrs:{"href":"#"}})
}
var staticRenderFns = []

export { render, staticRenderFns }